import { css } from "lit";
// Main colors to be defined by the theme
export const surfaceColor = css `var(--tc-surface-color, #F6FAFC)`; // 98
export const onSurfaceColor = css `var(--tc-on-surface-color, #001D32)`; // 10
export const surfaceContainerColor = css `var(--tc-surface-container-color, #E5EFF6)`; // 94
export const outlineColor = css `var(--tc-outline-color, #2C7CB5)`; // 50
export const outlineVariantColor = css `var(--tc-outline-variant-color, #ABCBE2)`; // 80
export const primaryColor = css `var(--tc-primary-color, #0061a6)`; // 40
export const secondarySurfaceColor = css `var(--tc-secondary-surface-color, #FDF8FA)`; // 98
export const secondaryOnSurfaceColor = css `var(--tc-secondary-on-surface-color, #3F0018)`; // 10
export const secondarySurfaceContainerColor = css `var(--tc-secondary-surface-container-color, #F9EAF0)`; // 94
export const secondaryOutlineColor = css `var(--tc-secondary-outline-color, #CE4379)`; // 50
export const secondaryColor = css `var(--tc-secondary-color, #BC0049)`; // 40
export const tertiarySurfaceColor = css `var(--tc-tertiary-surface-color, #FAF9F6)`; // 98
export const tertiaryOnSurfaceColor = css `var(--tc-tertiary-on-surface-color, #241A00)`; // 10
export const tertiarySurfaceContainerColor = css `var(--tc-tertiary-surface-container-color, #F2EDE4)`; // 94
export const tertiaryOutlineColor = css `var(--tc-tertiary-outline-color, #98702C)`; // 50
export const tertiaryColor = css `var(--tc-tertiary-color, #795900)`; // 40
export const monospace = css `var(--tc-font-monospace, sfmono-regular, menlo, monaco, consolas, "Liberation Mono", "Courier New", monospace)`;
export const immutable = css `
    :host, :host  * {
        --tc-surface-color: ${secondarySurfaceColor};
        --tc-on-surface-color: ${secondaryOnSurfaceColor};
        --tc-surface-container-color: ${secondarySurfaceContainerColor};
        --tc-outline-color: ${secondaryOutlineColor};
        --tc-primary-color: ${secondaryColor};
    }
`;
export const mutable = css `
    :host, :host * {
        --tc-surface-color: ${tertiarySurfaceColor};
        --tc-on-surface-color: ${tertiaryOnSurfaceColor};
        --tc-surface-container-color: ${tertiarySurfaceContainerColor};
        --tc-outline-color: ${tertiaryOutlineColor};
        --tc-primary-color: ${tertiaryColor};
    }
`;
export const defaults = css `
    :host {
        font-family: var(--tc-font-family, roboto, "Helvetica Neue", helvetica, arial, sans-serif);
        font-size: var(--tc-font-size, 13px);
        color: ${onSurfaceColor};
    }
  
  td {
    padding: 6px;
    background-color: ${surfaceColor};
  }
`;
export const heapDefaults = css `
  label {
    color: var(--tc-heap-label-color, ${primaryColor});
    font-size: var(--tc-heap-label-font-size, 10px);
    margin-bottom: 2px;
    display: block;
  }

  table {
       border-collapse: collapse; 
       border-radius: 5px; 
       overflow: hidden;
       border-style: hidden;
  }
  
  td {
    padding: 8px;
  }
`;
export const keyValueTable = css `  
    td.key {
        background-color: ${surfaceContainerColor};
        text-align: right;
        vertical-align: middle;
    }
    td {
        border-bottom: 1px solid ${outlineColor};
        font-size: 12px;
    }
`;
export const indexedTable = css `
    td {
        border-left: 1px solid ${outlineColor};
    }
    tbody td {
        padding-top: 2px;
        background-color: ${surfaceContainerColor};
    }
    thead td{
        background-color: ${surfaceContainerColor};
        color: ${outlineColor};
        font-size: 10px;
        padding-bottom: 2px;
    }
`;
//# sourceMappingURL=style.js.map